import { LocalStorageKey } from '@common/ts/enums';
import { iframeLocalStorage } from 'chat-ui/src/utils/iframeLocalStorage';

interface useScreeningLocalStorageProps {
  projectStorageSuffix: string | undefined;
}

const useScreeningLocalStorage = ({ projectStorageSuffix }: useScreeningLocalStorageProps) => {
  const getItem = (key: LocalStorageKey) =>
    iframeLocalStorage.getItem(`${key}${projectStorageSuffix}`);

  const storedConversationId = getItem(LocalStorageKey.CURRENT_CONVERSATION_ID);
  const screeningQuestionIndex = +(getItem(LocalStorageKey.SCREENING_QUESTION_INDEX) ?? '0');
  const disqualificationRedirectUrl = getItem(LocalStorageKey.SCREENING_QUESTION_DISQUALIFY_LINK);
  const quotaFullRedirectUrl = getItem(LocalStorageKey.SCREENING_QUESTION_QUOTA_FULL_LINK);
  const projectLanguageLabel = getItem(LocalStorageKey.CURRENT_PROJECT_LANGUAGE);
  const projectLanguageCode = getItem(LocalStorageKey.CURRENT_PROJECT_LANGUAGE_CODE);

  return {
    storedConversationId,
    screeningQuestionIndex,
    disqualificationRedirectUrl,
    quotaFullRedirectUrl,
    projectLanguageLabel,
    projectLanguageCode,
  };
};

export default useScreeningLocalStorage;
